import { render, staticRenderFns } from "./m-trim-example.vue?vue&type=template&id=c01f69a4&scoped=true&"
import script from "./m-trim-example.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-trim-example.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-trim-example.vue?vue&type=style&index=0&id=c01f69a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f69a4",
  null
  
)

export default component.exports